import { render } from "./AppAbout.vue?vue&type=template&id=b071e240&scoped=true"
const script = {}

import "./AppAbout.vue?vue&type=style&index=0&id=b071e240&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b071e240"]])

export default __exports__